import {
  defineUIInstanceCatalog,
  semanticSurface,
  UIAction,
  UIResource,
} from '@amzn/takt-semantics';
import { chromeComponents } from 'src/constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';

// Generic breadcrumb surface; shared by every Console page's breadcrumbs.
export const BREADCRUMBS_SURFACE = 'aac_chrome_breadcrumbs';

export const breadcrumbInstances = defineUIInstanceCatalog({
  chrome: {
    [UIResource.LINK]: {
      BREADCRUMB: 'breadcrumb',
    },
    [UIResource.MENU]: {
      BREADCRUMB: 'breadcrumb',
    },
  },
});

const chrome = semanticSurface(BREADCRUMBS_SURFACE, {
  instances: breadcrumbInstances,
}).chrome();

// Declarative twin for a breadcrumb navigation; legacy id and value stay byte-for-byte on the same node.
export const breadcrumbTwinAttributes = (
  id: string,
  value: Record<string, string>,
) => {
  const legacy = getTaktAttributes(id, chromeComponents.HEADER, value);
  if (!legacy) return undefined;
  return chrome.control(
    UIResource.LINK,
    UIAction.NAVIGATE,
    breadcrumbInstances.chrome[UIResource.LINK].BREADCRUMB,
    {
      legacy: {
        id: legacy['data-takt-id'],
        ...(legacy['data-takt-value'] !== undefined && {
          value: legacy['data-takt-value'],
        }),
      },
    },
  );
};

// Governed-only descriptor for the truncation-menu open trigger; no legacy id today.
export const breadcrumbMenuOpenAttributes = () =>
  chrome.control(
    UIResource.MENU,
    UIAction.OPEN,
    breadcrumbInstances.chrome[UIResource.MENU].BREADCRUMB,
  );
